/**
 * Created by r4zi4l on 09.09.2022
 */

const SnapshotAdapters = {
    random: {
        getInfo: () => PseudoRandom.GET().state,

        updateInfo: (serverData) => {
            PseudoRandom.GET().state = serverData || 0;
        }
    },

    abtest: {
        getInfo: () => cleverapps.abExperiments.groups,

        updateInfo: (serverData) => cleverapps.dataLoader.save(DataLoader.TYPES.ABTEST, serverData)
        
    },

    playSession: {
        getInfo: () => cleverapps.playSession.getInfo(),

        updateInfo: (serverData) => cleverapps.playSession.updateInfo(serverData)
    },

    scene: {
        getInfo: () => {
            if (typeof Game !== "undefined" && Game.currentGame && Game.currentGame.level && Game.currentGame.level.episodeNo !== undefined && Game.currentGame.level.levelNo !== undefined && !cleverapps.environment.isMainScene()) {
                return {
                    location: cleverapps.meta.selectedLocationId(),
                    episodeNo: Game.currentGame.level.episodeNo,
                    levelNo: Game.currentGame.level.levelNo,
                    levelType: Game.currentGame.level.levelType
                };
            }

            if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation) {
                return {
                    location: cleverapps.meta.selectedLocationId(),
                    episodeNo: cleverapps.meta.selectedLocationId(),
                    levelNo: 0
                };
            }

            if (typeof Merge2 !== "undefined" && Merge2.current) {
                return {
                    location: cleverapps.meta.selectedLocationId(),
                    episodeNo: cleverapps.meta.selectedLocationId(),
                    levelNo: 0
                };
            }
        }
    },

    flags: {
        getInfo: () => Object.keys(cleverapps.gameModes).filter((flagName) => cleverapps.gameModes[flagName]),

        updateInfo: (serverData) => {
            if (!serverData) {
                return;
            }

            Object.keys(cleverapps.gameModes).forEach((flagName) => {
                cleverapps.gameModes[flagName] = serverData.indexOf(flagName) !== -1;
            });
            cleverapps.gameModes.save();
        }
    },

    users: {
        getInfo: () => {
            const data = SyncAdapters.users.getInfo();
            if (data) {
                data.forcedVisited = data.visited;
            }

            return Object.assign(data || {}, cleverapps.info.data, {
                country: cleverapps.country.country,
                payerLevel: cleverapps.paymentsHistory.classify(),
                userIdsHistory: cleverapps.userIdsHistory.ids.join(","),
                defaultLanguage: cleverapps.Settings.getDefaultLanguage()
            });
        },

        updateInfo: (serverData) => {
            if (cleverapps.user) {
                serverData.forcedVisited = serverData.forcedVisited || Date.now();
                cleverapps.user.updateInfo(serverData);
            }
        }
    },

    placements: {
        getInfo: () => {
            const data = cleverapps.placements.getInfo();
            data.onceStarts = cleverapps.clone(cleverapps.placements.onceStarts);

            if (cleverapps.fallSale && cleverapps.focusManager.currentWindow() instanceof FallSaleWindow) {
                delete data.onceStarts.fallSaleWindow;
            }

            return data;
        },

        updateInfo: (data) => {
            if (data) {
                cleverapps.dataLoader.save(DataLoader.TYPES.PLACEMENTS, data);
            }

            cleverapps.placements.load();
        }
    },

    games: {
        getInfo: () => {
            if (SyncAdapters.games && SyncAdapters.games.getInfo) {
                return SyncAdapters.games.getInfo();
            }

            const data = typeof Game !== "undefined" && Game.currentGame && Game.currentGame.getInfo();
            if (!data) {
                return;
            }

            if (!data.keypad && Game.currentGame.keypad) {
                data.keypad = Game.currentGame.keypad.getInfo();
            }

            if (Game.currentGame.scoreBar) {
                data.scoreBar = Game.currentGame.scoreBar.getInfo();
            }

            return Object.assign(data, {
                level: Game.currentGame.level.levelNo,
                episode: Game.currentGame.level.episodeNo
            });
        },

        updateInfo: (serverData) => {
            if (SyncAdapters.games && SyncAdapters.games.updateInfo) {
                return SyncAdapters.games.updateInfo(serverData);
            }
        }
    },

    travelBook: {
        getInfo: () => {
            if (!cleverapps.travelBook) {
                return;
            }

            const data = {};

            cleverapps.travelBook.listAllPages().forEach((page) => {
                const pageData = cleverapps.dataLoader.load(DataLoader.TYPES.TRAVEL_BOOK_EVENTS + page.id);
                if (pageData) {
                    data[page.id] = pageData;
                }
            });

            return data;
        },

        updateInfo: (data) => {
            if (!cleverapps.travelBook) {
                return;
            }

            cleverapps.travelBook.listAllPages().forEach((page) => {
                if (data[page.id]) {
                    cleverapps.dataLoader.save(DataLoader.TYPES.TRAVEL_BOOK_EVENTS + page.id, data[page.id]);
                } else {
                    cleverapps.dataLoader.remove(DataLoader.TYPES.TRAVEL_BOOK_EVENTS + page.id);
                }
            });
        }
    },

    travelBookAttention: {
        getInfo: () => {
            if (!cleverapps.travelBook) {
                return;
            }

            const data = {};

            cleverapps.travelBook.listAllPages().forEach((page) => {
                const attention = cleverapps.dataLoader.load(DataLoader.TYPES.TRAVEL_BOOK_ATTENTION + page.id);
                if (attention) {
                    data[page.id] = attention;
                }
            });

            return data;
        },

        updateInfo: (data) => {
            if (!cleverapps.travelBook) {
                return;
            }

            cleverapps.travelBook.listAllPages().forEach((page) => {
                if (data[page.id]) {
                    cleverapps.dataLoader.save(DataLoader.TYPES.TRAVEL_BOOK_ATTENTION + page.id, data[page.id]);
                } else {
                    cleverapps.dataLoader.remove(DataLoader.TYPES.TRAVEL_BOOK_ATTENTION + page.id);
                }
            });
        }
    },

    clan: {
        getInfo: () => {
            if (!cleverapps.userClan || !cleverapps.userClan.id) {
                return;
            }

            const data = cleverapps.userClan.getInfo();
            data.players = cleverapps.userClan.players.map((player) => player.getInfo());
            data.messages = cleverapps.clanMessages.listMessages().map((message) => message.getInfo());

            return data;
        },

        updateInfo: () => {
            if (cleverapps.userClan && cleverapps.clanMessages) {
                cleverapps.userClan.load();
                cleverapps.clanMessages.loadMessages();
            }
        }
    },

    ads: {
        getInfo: () => {
            const data = {
                enabled: connector.ads.isRewardedSupported,
                running: connector.ads.isInterstitialPlaying && cleverapps.rewardedAdsManager.prerollStatus !== RewardedAdsManager.PREROL_SHOWING
            };
            if (cleverapps.rewardedAdsManager.prerollStatus === RewardedAdsManager.PREROL_SHOWN) {
                data.prerollStatus = RewardedAdsManager.PREROL_SHOWN;
            }
            return data;
        },

        updateInfo: (data) => {
            if (!data || (typeof data === "object" && !data.enabled)) {
                connector.ads.getPlugin().setStatus(connector.STATUS_DISABLED);
                connector.config.disableReconnect = true;
            }
            cleverapps.rewardedAdsManager.prerollStatus = data.prerollStatus;
        }
    },

    isLoggedIn: {
        getInfo: () => connector.social.isLoggedIn()
    },

    // read only: the CRM shows the player's screen and input next to a message, import skips it
    device: {
        getInfo: () => {
            const frame = cleverapps.resolution.getFrameSize();
            const coarse = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
            const os = new UAParser().getResult(window.navigator.userAgent).os;
            const useragent = cleverapps.info.getUserAgent();

            return {
                width: Math.round(frame.width),
                height: Math.round(frame.height),
                dpr: window.devicePixelRatio || 1,
                input: coarse ? "touch" : "mouse",
                touchPoints: window.navigator.maxTouchPoints || 0,
                os: [os.name, os.version].filter(Boolean).join(" "),
                browser: [useragent.browser, useragent.version].filter(Boolean).join(" ")
            };
        }
    },

    specialEnergyOffer: {
        getInfo: () => {
            if (typeof SpecialEnergyOffer !== "undefined") {
                return cleverapps.dataLoader.load(DataLoader.TYPES.SPECIAL_LIVES_OFFER_LAST_TIME) || {};
            }
        },

        updateInfo: (data) => cleverapps.dataLoader.save(DataLoader.TYPES.SPECIAL_LIVES_OFFER_LAST_TIME, data)

    },

    events: {
        getInfo: () => {
            if (!cleverapps.eventManager) {
                return;
            }
            return cleverapps.eventManager.events.map((event) => event.getInfo());
        },

        updateInfo: (serverData) => {
            if (!cleverapps.eventManager) {
                return;
            }
            const schedule = bundles.main.jsons.friday_schedule ? bundles.main.jsons.friday_schedule.getJson() : [];
            const scheduleFeatures = new Set(schedule.flatMap((event) => event.features || []));
            const key = (eventData) => JSON.stringify([eventData.features, eventData.start, eventData.finish]);
            const known = new Set(serverData.map(key));
            const scheduled = new Map(schedule.map((eventData) => [key(eventData), eventData]));
            const missing = schedule.filter((eventData) => !known.has(key(eventData)) && (!eventData.debug || cleverapps.config.debugMode));
            cleverapps.eventManager.events = serverData.map((eventData) => scheduled.get(key(eventData)) || eventData).concat(missing)
                .filter((eventData) => (eventData.features || []).every((feature) => cleverapps.config.features.includes(feature) || scheduleFeatures.has(feature)))
                .map((eventData) => new cleverapps.Event(eventData));
            cleverapps.eventManager.setCurrentFeatures();
        }
    },

    stickersBookAttention: {
        getInfo: () => {
            if (!cleverapps.stickersBook) {
                return;
            }
            return cleverapps.stickersBook.getAttentionInfo();
        },

        updateInfo: (data) => {
            if (!cleverapps.stickersBook) {
                return;
            }
            cleverapps.stickersBook.updateAttention(data);
        }
    },

    achievementsAttention: {
        getInfo: () => cleverapps.achievements && cleverapps.achievements.hasAttention(),

        updateInfo: (data) => cleverapps.achievements && cleverapps.achievements.setAttention(data)
    },

    rumble: {
        getInfo: () => {
            const rumble = cleverapps.knockoutGame && cleverapps.knockoutGame.rumble;
            if (!rumble) {
                return;
            }

            return rumble.getInfo();
        },

        updateInfo: (data) => cleverapps.dataLoader.save(DataLoader.TYPES.RUMBLE, data)
        
    },

    knockout: {
        getInfo: () => {
            if (typeof Game === "undefined" || !Game.currentGame || !Game.currentGame.competition || !Game.currentGame.competition.options || Game.currentGame.competition.options.type !== "knockout") {
                return;
            }

            const opponentView = cleverapps.Scenes.GetSceneComponent(GameSceneComponent).playersView.opponentView;

            return opponentView.getOpenedPoints && opponentView.getOpenedPoints();
        },

        updateInfo: (data) => cleverapps.dataLoader.save(`${DataLoader.TYPES.COMPETITION}_knockout`, data)
        
    },

    adsLimits: {
        getInfo: () => cleverapps.adsLimits.getInfo(),

        updateInfo: (data) => {
            cleverapps.dataLoader.save(DataLoader.TYPES.ADS_LIMITS_DATA, data);

            cleverapps.adsLimits.load();
        }
    },

    tutorial: {
        getInfo: () => {
            if (cleverapps.tutorial) {
                return cleverapps.tutorial.getInfo();
            }
        }
    },

    friendRequests: {
        getInfo: () => {
            if (levels.friendRequests) {
                const notProcessed = [];
                for (let i = 0; i < levels.friendRequests.notProcessed.length; i++) {
                    notProcessed.push(levels.friendRequests.notProcessed[i].getData());
                }

                return {
                    notProcessed,
                    processedIds: levels.friendRequests.processedIds
                };
            }
        },

        updateInfo: (serverData) => {
            if (levels.friendRequests) {
                cleverapps.dataLoader.save(DataLoader.TYPES.FRIEND_REQUESTS, {
                    notProcessed: serverData.notProcessed,
                    processedIds: serverData.processedIds
                });
            }
        }
    },

    simpleAlgorithm: {
        getInfo: () => {
            if (typeof SimpleAlgorithm === "undefined") {
                return;
            }

            return cleverapps.dataLoader.load(DataLoader.TYPES.SIMPLE_ALGORITHM);
        },

        updateInfo: (serverData) => {
            if (typeof SimpleAlgorithm === "undefined") {
                return;
            }

            cleverapps.dataLoader.save(DataLoader.TYPES.SIMPLE_ALGORITHM, serverData);
        }
    },

    orderManager: {
        getInfo: () => {
            if (typeof OrderManager === "undefined") {
                return;
            }
            return cleverapps.dataLoader.load(DataLoader.TYPES.ORDER_MANAGER);
        },

        updateInfo: (serverData) => {
            if (typeof OrderManager === "undefined") {
                return;
            }

            cleverapps.dataLoader.save(DataLoader.TYPES.ORDER_MANAGER, serverData);
        }
    },

    personalBest: {
        getInfo: () => cleverapps.personalBest.getData(),

        updateInfo: (data) => {
            cleverapps.dataLoader.save(DataLoader.TYPES.PERSONAL_BEST, data);
            cleverapps.personalBest.load();
        }
    },

    raveReviews: {
        getInfo: () => {
            if (!cleverapps.raveReviews) {
                return;
            }

            return cleverapps.raveReviews.getInfo();
        },

        updateInfo: (serverData) => {
            if (!cleverapps.raveReviews) {
                return;
            }

            cleverapps.raveReviews.updateInfo(serverData);
        }
    },

    customers_cooldowns: {
        getInfo: () => {
            if (typeof Merge2Customers === "undefined") {
                return;
            }

            return cleverapps.dataLoader.load(DataLoader.TYPES.CUSTOMERS_QUEUE);
        },

        updateInfo: (serverData) => {
            if (typeof Merge2Customers === "undefined") {
                return;
            }

            cleverapps.dataLoader.save(DataLoader.TYPES.CUSTOMERS_QUEUE, serverData);
        }
    },

    hungrygamesorder: {
        getInfo: () => {
            if (typeof HungryGamesOrder === "undefined") {
                return;
            }

            return cleverapps.dataLoader.load(DataLoader.TYPES.HUNGRY_GAMES_MERGE2);
        },

        updateInfo: (serverData) => {
            if (typeof HungryGamesOrder === "undefined") {
                return;
            }

            cleverapps.dataLoader.save(DataLoader.TYPES.HUNGRY_GAMES_MERGE2, serverData);
        }
    },

    energyBooster: {
        getInfo: () => {
            if (typeof EnergyBooster === "undefined") {
                return;
            }

            return cleverapps.dataLoader.load(DataLoader.TYPES.ENERGY_BOOSTER) || {};
        },

        updateInfo: (serverData) => {
            if (typeof EnergyBooster === "undefined") {
                return;
            }

            cleverapps.dataLoader.save(DataLoader.TYPES.ENERGY_BOOSTER, serverData);

            if (cleverapps.energyBooster) {
                cleverapps.energyBooster.load();
                cleverapps.energyBooster.scheduleExpire();
            }
        }
    },

    gameAnnounce: {
        getInfo: () => {
            if (typeof GameAnnounce !== "undefined") {
                return cleverapps.dataLoader.load(DataLoader.TYPES.GAME_ANNOUNCE) || {};
            }
        },

        beforeUpdate: () => {
            cleverapps.dataLoader.remove(DataLoader.TYPES.GAME_ANNOUNCE);
        },

        updateInfo: (data) => {
            if (typeof GameAnnounce !== "undefined") {
                cleverapps.dataLoader.save(DataLoader.TYPES.GAME_ANNOUNCE, data);
            }
        }
    },

    subscription: {
        updateInfo: (data) => {
            data[connector.info.source] = Object.values(data)[0];
            cleverapps.subscription.updateInfo(data);
        }
    },

    settings: {
        updateInfo: (serverData) => {
            const hashParams = cleverapps.getRequestParameters(location.hash);

            const language = hashParams.lang || serverData.language;

            if (language) {
                cleverapps.settings.setLanguage(language);
                cleverapps.settings.updateDependents();

                Messages.loadLanguage(language, () => {});
            }

            if (serverData.music !== undefined) {
                cleverapps.settings.music = serverData.music;
            }

            if (serverData.sound !== undefined) {
                cleverapps.settings.sound = serverData.sound;
            }
        }
    },

    boardFullHelper: {
        getInfo: () => {
            if (typeof BoardFullHelper === "undefined") {
                return;
            }
            return cleverapps.dataLoader.load(DataLoader.TYPES.BOARD_FULL_HINT);
        },

        updateInfo: (serverData) => {
            if (typeof BoardFullHelper === "undefined") {
                return;
            }

            cleverapps.dataLoader.save(DataLoader.TYPES.BOARD_FULL_HINT, serverData);
        }
    }

};

SnapshotAdapters.extractData = function (callback) {
    const waiter = cleverapps.wait(2, () => {
        const extractors = {};
        for (const type in SyncAdapters) {
            if (type.indexOf("units_") === 0) {
                continue;
            }

            extractors[type] = SyncAdapters[type].getInfo;
        }

        for (const type in SnapshotAdapters) {
            extractors[type] = SnapshotAdapters[type].getInfo || extractors[type];
        }

        const data = {};
        data.date = Date.now();

        for (const type in extractors) {
            const extractor = extractors[type];
            if (!extractor) {
                continue;
            }

            data[type] = extractor();
        }

        callback(data);
    });

    if (cleverapps.userClan && !connector.config.norest) {
        cleverapps.userClan.load(waiter, waiter, {
            ignoreNoRest: true
        });
        cleverapps.clanMessages.loadMessages(waiter);
    } else {
        waiter();
        waiter();
    }
};

SnapshotAdapters.registerBySlots = function (name, adapter) {
    Meta.SLOTS.forEach((slotId) => {
        this[name + slotId] = {
            getInfo: () => adapter.getInfo(slotId),
            updateInfo: (serverData) => adapter.updateInfo(slotId, serverData)
        };
    });
};

SnapshotAdapters.loadFromSlot = function (slotId, key) {
    return cleverapps.dataSlots.getSlot(slotId).load(key);
};

SnapshotAdapters.saveToSlot = function (slotId, key, serverData) {
    if (serverData) {
        cleverapps.dataSlots.getSlot(slotId).save(key, serverData);
    } else {
        cleverapps.dataSlots.getSlot(slotId).remove(key);
    }
};

SnapshotAdapters.registerBySlots("units", {
    getInfo: (slotId) => {
        const unitsSyncer = cleverapps.unitsSyncers && cleverapps.unitsSyncers.getInstance(slotId);
        if (!unitsSyncer) {
            return;
        }

        return unitsSyncer.getInfo();
    },

    updateInfo: (slotId, serverData) => {
        const unitsSyncer = cleverapps.unitsSyncers && cleverapps.unitsSyncers.getInstance(slotId);
        if (!unitsSyncer) {
            return;
        }
        unitsSyncer.updateInfo(serverData);
    }
});

SnapshotAdapters.registerBySlots("map2d", {
    getInfo: (slotId) => SnapshotAdapters.loadFromSlot(slotId, "local_map2d"),
    updateInfo: (slotId, serverData) => SnapshotAdapters.saveToSlot(slotId, "local_map2d", serverData)
});

SnapshotAdapters.registerBySlots("map2dmerge", {
    getInfo: (slotId) => SnapshotAdapters.loadFromSlot(slotId, "local_map2d"),
    updateInfo: (slotId, serverData) => SnapshotAdapters.saveToSlot(slotId, "local_map2d", serverData)
});

SnapshotAdapters.registerBySlots("freeworker", {
    getInfo: (slotId) => SnapshotAdapters.loadFromSlot(slotId, "local_free_worker"),
    updateInfo: (slotId, serverData) => SnapshotAdapters.saveToSlot(slotId, "local_free_worker", serverData)
});

SnapshotAdapters.registerBySlots("freeworkermerge", {
    getInfo: (slotId) => SnapshotAdapters.loadFromSlot(slotId, "local_free_worker"),
    updateInfo: (slotId, serverData) => SnapshotAdapters.saveToSlot(slotId, "local_free_worker", serverData)
});

SnapshotAdapters.registerBySlots("thirdElements", {
    getInfo: (slotId) => SnapshotAdapters.loadFromSlot(slotId, "local_thirdelements_usage"),
    updateInfo: (slotId, serverData) => SnapshotAdapters.saveToSlot(slotId, "local_thirdelements_usage", serverData)
});

SnapshotAdapters.registerBySlots("thirdElementsmerge", {
    getInfo: (slotId) => SnapshotAdapters.loadFromSlot(slotId, "local_thirdelements_planner"),
    updateInfo: (slotId, serverData) => SnapshotAdapters.saveToSlot(slotId, "local_thirdelements_planner", serverData)
});

SnapshotAdapters.registerBySlots("pathIndicatormerge", {
    getInfo: (slotId) => SnapshotAdapters.loadFromSlot(slotId, "local_pathindicator_cell"),
    updateInfo: (slotId, serverData) => SnapshotAdapters.saveToSlot(slotId, "local_pathindicator_cell", serverData)
});

SnapshotAdapters.registerBySlots("energyProducts", {
    getInfo: (slotId) => SnapshotAdapters.loadFromSlot(slotId, "local_energy_products"),
    updateInfo: (slotId, serverData) => SnapshotAdapters.saveToSlot(slotId, "local_energy_products", serverData)
});
